module.exports = __webpack_public_path__ + "media/images/symbols/instagram-social-93080c576a877016c3c011d2cdbb4e33.svg";